var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "progress-bar-container" } },
    [
      _c("vue-content-loading", { attrs: { width: 1200, height: 70 } }, [
        _c("circle", { attrs: { cx: "41.7", cy: "32.7", r: "18" } }),
        _vm._v(" "),
        _c("circle", { attrs: { cx: "362.7", cy: "32.7", r: "18" } }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "69.13",
            y: "30",
            rx: "0",
            ry: "0",
            width: "261.88",
            height: "7",
          },
        }),
        _vm._v(" "),
        _c("circle", { attrs: { cx: "998.7", cy: "32.7", r: "18" } }),
        _vm._v(" "),
        _c("circle", { attrs: { cx: "684.7", cy: "32.7", r: "18" } }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "398.13",
            y: "30",
            rx: "0",
            ry: "0",
            width: "261.88",
            height: "7",
          },
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "716.13",
            y: "30",
            rx: "0",
            ry: "0",
            width: "261.88",
            height: "7",
          },
        }),
        _vm._v(" "),
        _c("rect", {
          attrs: {
            x: "1023.13",
            y: "30",
            rx: "0",
            ry: "0",
            width: "261.88",
            height: "7",
          },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }